mutation CreateChatBan($input: CreateChatBanInput!) {
  createChatBan(input: $input) {
    id
  }
}
